<div class="status-block">
  <div class="first-text {{ firstTextColor }}" [ngClass]="{ 'with-triangle': !!secondText }">{{ firstText | translate }}</div>
  <div class="first-text {{ firstTextColor }} empty" [ngClass]="{ triangle: !!secondText }"></div>
  <ng-container *ngIf="secondText">
    <ng-container *ngIf="pointColor">
      <div class="point {{ pointColor }}"></div>
    </ng-container>
    <div class="hint-text">{{ secondText | translate }}</div>
  </ng-container>
</div>
